import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { hot } from 'react-hot-loader';

export default hot(module)(function (props) {
	return (
		<Grid item sm={6} xs={12} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave}>
			<Paper>
				<Typography component="h3" variant="h5">
					<p>{props.children}</p>
				</Typography>
			</Paper>
		</Grid>
	);
});
